import React from "react";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import eKey from "../../../assets/images/eKey.webp";

const ContinueBtn = ({ onClick, loading }) => {
  const translate = useLanguageTranslate();

  return (
    <div>
      {/* A real button: it was a clickable div, so it could not be reached
          from the keyboard or announced as a button. */}
      <button
        type="button"
        disabled={loading}
        className={`w-full flex flex-col border border-[#DDE2E4] pt-[15px] pb-[15px] justify-center items-center rounded-lg bg-white cursor-pointer transition-transform duration-150 ease-out active:scale-[0.98] ${
          loading ? "opacity-60 pointer-events-none" : ""
        }`}
        onClick={onClick}
      >
        <div className="flex flex-row items-center">
          <div
            className="bg-no-repeat bg-auto h-[24px] w-[56px] bg-cover"
            style={{
              backgroundImage: `url(${eKey})`,
              backgroundPosition: "bottom right",
            }}
          ></div>
          {loading ? (
            <div className="pl-[10px] text-xl font-semibold">
              <svg
                className="animate-spin h-6 w-6 text-[#00A9E7]"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                ></path>
              </svg>
            </div>
          ) : (
            <span className="pl-[10px] rtl:pl-0 rtl:pr-[10px] text-xl font-semibold">
              {translate(
                "Continue with eKey 2.0",
                "الدخول بالمفتاح الإلكتروني 2.0"
              )}
            </span>
          )}
        </div>
      </button>
      {/* Even space either side, so "or" belongs to neither the button above
          nor the field below (it sat 3px off the CPR label). */}
      <div className="flex items-center gap-3 my-4">
        <span className="h-px flex-1 bg-[#E5E9EB]" />
        <span className="text-[#5B6871] text-base not-italic font-normal">
          {translate("or", "أو")}
        </span>
        <span className="h-px flex-1 bg-[#E5E9EB]" />
      </div>
    </div>
  );
};

export default ContinueBtn;
